module.exports = __webpack_public_path__ + "img/reportSuccess.c33530a2.png";